import { MRT_ColumnFiltersState } from "material-react-table";

export const normalizeColumnFilters = (filters: MRT_ColumnFiltersState) =>
  (filters || [])
    .filter((filter) => {
      const value = filter?.value;
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim().length > 0;
      if (Array.isArray(value)) return value.length > 0;
      return true;
    })
    .map((filter) => {
      const value =
        typeof filter.value === "string" ? filter.value.trim() : filter.value;
      return { id: filter.id, value };
    });

export const areColumnFiltersEqual = (
  left: MRT_ColumnFiltersState,
  right: MRT_ColumnFiltersState
) =>
  JSON.stringify(normalizeColumnFilters(left)) ===
  JSON.stringify(normalizeColumnFilters(right));

const normalizeString = (value: any) => String(value ?? "").trim().toLowerCase();

const doesRowMatchFilter = (row: any, filter: { id: string; value: any }) => {
  const rowValue = row?.[filter.id];

  if (Array.isArray(filter.value)) {
    if (filter.value.length === 0) return true;
    const rowText = normalizeString(rowValue);
    return filter.value.some(
      (optionValue: any) => rowText === normalizeString(optionValue)
    );
  }

  if (typeof filter.value === "string") {
    const filterText = normalizeString(filter.value);
    if (!filterText) return true;
    return normalizeString(rowValue).includes(filterText);
  }

  return rowValue === filter.value;
};

export const filterRowsByColumnFilters = (
  rows: any[],
  columnFilters: MRT_ColumnFiltersState
) => {
  const activeFilters = normalizeColumnFilters(columnFilters);
  if (!activeFilters.length) {
    return rows;
  }

  return (rows || []).filter((row: any) =>
    activeFilters.every((filter: any) => doesRowMatchFilter(row, filter))
  );
};
